<ng-container *transloco="let t">
  <div class="page-wrapper flex flex-col">
    <div class="flex w-full justify-between">
      <div class="mr-2 flex min-w-0 flex-1 items-center">
        <ISelectMenu [value]="catalogFilterSelected()" (valueChange)="catalogFilterChanged($event)" popoverWidth="250">
          <ISelectTrigger>
            <ISelectValue>
              <div *iSelectValue="let value">
                {{ value.label }}
              </div>
            </ISelectValue>
          </ISelectTrigger>
          <ISelectContent>
            @for (option of catalogFilterDdOptions; track option.value) {
              <ISelectOption [value]="option">
                {{ option.label }}
              </ISelectOption>
            }
          </ISelectContent>
        </ISelectMenu>

        <div class="ml-2 min-w-0">
          <IMultiSelectMenu
            [value]="selectedSegments()"
            (valueChange)="segmentFilterChanged($event)"
            [(searchQuery)]="segmentQuery"
            popoverWidth="250"
          >
            <ISelectTrigger>
              <ISelectValue placeholder="{{ t('add-product-tracking-modal.product_segments') }}">
                <div *iSelectValue="let value">
                  {{ t("common.selected", { count: value.length }) }}
                </div>
              </ISelectValue>
            </ISelectTrigger>
            <ISelectContent>
              @for (segment of filteredSegments(); track segment.segmentId) {
                <ISelectOption [value]="segment">
                  <span class="truncate">
                    {{ segment.name }}
                  </span>
                </ISelectOption>
              }
            </ISelectContent>
          </IMultiSelectMenu>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <button iButton variant="secondary" (click)="setupGroupBy()">
          {{
            isGroupedByParent() ? t("product-tracker.split_by_child_asin") : t("product-tracker.group_by_parent_asin")
          }}
        </button>
        @if (keywordTrackingSupported()) {
          <button iButton [disabled]="(isReadOnly$ | async) === true" (click)="openAddProductTrackingModal()">
            <IIcon name="plus" />
            {{ t("add-product-tracking-modal.track_new_products") }}
          </button>
        }
        <app-export-button (export)="exportAsCsv()" tooltipValue="{{ t('common.export_as_csv') }}"></app-export-button>
      </div>
    </div>
    <div class="grid-wrapper ag-theme-quartz mt-3 flex-1">
      <ag-grid-angular
        style="width: 100%"
        class="h-full"
        [rowData]="gridData()"
        [gridOptions]="gridOptions"
      ></ag-grid-angular>
    </div>
  </div>
</ng-container>
